import React, { Component } from 'react'
import { connect } from 'react-redux'
import { EspacioPorCerealDetallesView } from '../components/EspacioPorCerealDetallesView'

class EspacioPorCerealDetalles extends Component {
  render () {
    return <EspacioPorCerealDetallesView />
  }
}

const withRedux = connect(null, null)

export default withRedux(EspacioPorCerealDetalles)
